const STORAGE_KEY = "Chat::sendMessageOnEnter";

export const getChatSendOnEnter = () => window.storage.getItem(STORAGE_KEY);

export const setChatSendOnEnter = (val) => window.storage.setItem("Chat::sendMessageOnEnter", !!val);
